export const statsDataHero = [
  { label: "Data Points", value: 5, unit: "M", prefix: "+" },
  { label: "Market Models", value: 10, unit: "", prefix: "+" },
  { label: "Smarter Data", value: 100, unit: "x", prefix: "" },
];


export const slidesRealtimeAiPowered = [
  {
    image: "/images/dashboardOverview.png",
    alt: "Dashboard Overview",
  },
  {
    image: "/images/performanceOverview.png",
    alt: "Performance Overview",
  },
  {
    image: "/images/realtimeTechnicals.png",
    alt: "Realtime Technicals",
  },
];


export const productsData = [
  {
    title: "Dashboard",
    description:
      "Experience the oracle Real time aggregated market data feed and impact predictions. trading strategy, indicators and more.",
    image: "/images/productDashboard2.png",
    isComingSoon: false,
  },
  {
    title: "Telegram App",
    description:
      "Access the Oracle, Discover market movements and trends on Telegram.",
    image: "/images/productTgApp2.png",
    isComingSoon: false,
  },
  {
    title: "AI AGENT",
    description:
      "Ypsilon receives real-time market data 24/7 from hundreds of thousands of market data points through Ÿ's Oracle model.",
    image: "/images/productVault.png",
    isComingSoon: false,
  },
  {
    title: "API Key",
    description:
      "Supercharge your application by accessing the most accurate, lowest-latency, and highest-resolution data.",
    image: "/images/productApi.png",
    link: "",
    isComingSoon: true,
  },
];


export const statsDataNetwork = [
  { label: "Data Points", value: 5, unit: "M", prefix: "+" },
  { label: "Market Models", value: 10, unit: "", prefix: "+" },
  { label: "Smarter Data", value: 100, unit: "x", prefix: "" },
];
